import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	NgbDropdownModule,
	NgbPaginationModule,
	NgbNavModule,
	NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		NgbDropdownModule,
		NgbNavModule,
		NgbTooltipModule,
		NgbPaginationModule,
	],
})
export class EmployeeUsersModule {}
